module.exports = __webpack_public_path__ + "static/media/bulkreportActive.51ffe808.svg";